import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { overviewQueryOptions } from "@/features/attendance/api/attendance.queries";
import { defaultWindowStart } from "@/features/attendance/attendance.config";
import { OverviewPage } from "@/features/attendance/OverviewPage";
import { meQueryOptions } from "@/features/auth/api/auth.queries";
import { canManageRaids } from "@/shared/lib/roles";

export const Route = createFileRoute("/_app/")({
  loader: ({ context }) =>
    context.queryClient.ensureQueryData(
      overviewQueryOptions(defaultWindowStart()),
    ),
  component: OverviewRoute,
});

// Passes the manage-raids flag down so attendance never imports auth.
// `me` is pre-warmed by _app.tsx beforeLoad, so this resolves from cache.
function OverviewRoute() {
  const { data: me } = useSuspenseQuery(meQueryOptions);
  return <OverviewPage canManageRaids={canManageRaids(me.permissionRole)} />;
}
